<template>
	<div style="height:100%;" align="Center" v-if="$store.getters.isInternalUser">
		<div id="overall-body">

			<!-- body start -->
			<div id="body-container" align="left">
				<table id="body-table" cellspacing="0" cellpadding="0">
					<tbody>
						<tr>

							<!-- MainBody Starts -->
							<td id="main-container">
								<!-- Main Content Starts -->

									<table width="100%" cellspacing="5" cellpadding="0" border="0">
										<tbody>
											<tr valign="top">

												<td valign="top" align="left">

													<div class="full-width">
														<div class="grid">
															<div class="col-8">

															</div>

															<div class="col-4">
																<div class="col css-image compass-logo" style="height:50px">
																</div>
															</div>
														</div>

														<div style="margin: 10px 0; text-align: center;">
															<span style="text-transform: uppercase; font-weight: bold; font-size: 18px; letter-spacing: 1px;">
																Certificate of compliance with inspection,<br>
																maintenance and reporting procedures
															</span><br>
															<span style="font-style: italic; font-weight: bold;">Section 108 (3)(c) Building Act 2004</span><br>
															<strong>FORM 12A</strong>
														</div>

														<div style="border: 1px solid black; padding: 5px; margin: 0.5rem 2rem;">
															<table width="100%" cellspacing="0" cellpadding="0" border="0">
																<tbody>
																	<tr>
																		<td width="60%" valign="top">Certificate issued by</td>
																		<td>
																			<strong>
																				Compass New Zealand Ltd<br>
																				Unit 2J, 3 Ceres Court,
																				Rosedale, Auckland
																			</strong>
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>

														<div style="border: 1px solid black; padding: 10px; margin: 0 2rem;">
															<table class="top-align-left-column" width="100%" cellspacing="0" cellpadding="0" border="0">
																<tbody>
																	<tr>
																		<td colspan="2" class="title">The Building</td>
																	</tr>
																	<tr>
																		<td>Compliance Schedule No:</td>
																		<td>{{bwof.complianceSchedule}}</td>
																	</tr>
																	<tr>
																		<td>Street Address of Building:</td>
																		<td>{{propertyData.streetAddress}} {{propertyData.suburb}} {{propertyData.city}}</td>
																	</tr>
																	<tr>
																		<td>Legal Description:</td>
																		<td>{{bwof.legalDescription}}</td>
																	</tr>
																	<tr>
																		<td>Building Name:</td>
																		<td>{{propertyData.buildingName}}</td>
																	</tr>
																	<tr>
																		<td>Location of Building within site/block number:</td>
																		<td>{{bwof.locationOfBuildingWithinSite}}</td>
																	</tr>
																	<tr>
																		<td>Level/Unit Number:</td>
																		<td>{{bwof.levelUnitNo}}</td>
																	</tr>
																	<tr>
																		<td colspan="2">&nbsp;</td>
																	</tr>
																	<tr>
																		<td colspan="2" class="title">The Owner</td>
																	</tr>
																	<tr>
																		<td>Name of Owner:</td>
																		<td>{{owner.companyName}}</td>
																	</tr>
																	<tr>
																		<td>Contact Person:</td>
																		<td>{{ownerContact.firstName}} {{ownerContact.lastName}}</td>
																	</tr>
																	<tr>
																		<td>Mailing Address:</td>
																		<td>{{owner.postalAddress}} {{owner.suburb}} {{owner.city}}</td>
																	</tr>
																	<tr>
																		<td>Street Address:</td>
																		<td>{{owner.streetAddress}}</td>
																	</tr>
																	<tr>
																		<td>Email Address:</td>
																		<td>{{ownerContact.email}}</td>
																	</tr>
																	<tr>
																		<td>Contact Number:</td>
																		<td>{{ ownerContact.ddi && ownerContact.ddi.trim() !== '' ? ownerContact.ddi : ownerContact.mobile }}</td>
																	</tr>
																</tbody>
															</table>
														</div>

														<div style="border: 1px solid black; padding: 10px; margin: 0.5rem 2rem;">
															Compass New Zealand Ltd certifies that the inspection, maintenance and
															reporting procedures of the Compliance Schedule have been fully complied
															with during the 
															<span v-if="bwof.complianceScheduleMonths == 1">{{bwof.complianceScheduleMonths}} month</span><span v-else>{{bwof.complianceScheduleMonths}} months</span>
															 prior to the date stated below in relation to
															the following specified system/s:

															<br>

															<div style="margin: 10px 0;">
																<table style="min-height: 75px; display: flex;">
																	<tbody>

																		<!--for each specified system or feature-->
																		<template v-for="srv in visibleServices" v-bind:key="srv.serviceId">
																			<tr><td><span>{{srv.ref}}</span></td><td>{{srv.serviceName}}</td></tr>
																		</template>

																	</tbody>
																</table>
															</div>
															<div style="height: 75px; font-weight: bold;">
																SIGNATURE OF IQP # <span v-if="bwof.issuedBy == 'John'">110474</span><span v-else>110459</span>:
																<div style="margin-left: 10px; padding: 10px 40px;">
																	<div class="document-text-border col mr-4 mt-1 css-image" style="height:30px" v-bind:class="[bwof.issuedBy == 'John' ? 'signature-john':'signature-keith' ]">
																	</div>
																</div>
															</div>
															<div>
																<table width="100%">
																	<tbody>
																		<tr>
																			<td width="60%"><strong>NAME:</strong> <span v-if="bwof.issuedBy == 'John'">John Bell</span><span v-else>Keith Flatt</span></td>
																			<td><strong>DATE:</strong> {{formattedDate(issuedDate)}}</td>
																		</tr>
																	</tbody>
																</table>
															</div>

														</div>

													</div>

												</td>

											</tr>
										</tbody>
									</table>
							</td><!-- MainBody Ends -->
						</tr>
					</tbody>
				</table>
			</div>
			<!-- body end -->
		</div>
	</div>
</template>

<script lang="ts">
	import { Vue, Options } from 'vue-class-component';
	import { PropertyData, CompanyData, ContactData, PropertyServiceData, PropertyBwofData } from '@/api-client/api-client'
	import { format, isValid } from 'date-fns';
	import { Get12aPropertyServicesForSupplier } from '@/utils/CompassConstants'

	@Options({
		name: 'CertificateOfComplianceTemplate',
		props: {
			propertyData: null,
			service: null,
			issuedDate: null,
		}
	})
	export default class CertificateOfComplianceTemplate extends Vue {

		// Data
		propertyData: PropertyData = new PropertyData();
		ownerContact: ContactData = new ContactData;
		service: PropertyServiceData = new PropertyServiceData;
		owner: CompanyData = new CompanyData;
		bwof: PropertyBwofData = new PropertyBwofData;
		issuedDate!: Date;

		created() {
			if (this.propertyData) {
				// Set Owner
				this.owner = this.propertyData.owner ? this.propertyData.owner : this.owner;

				if (this.propertyData.ownerContacts?.length) {
					this.ownerContact = this.propertyData.ownerContacts[0];
				}

				if (this.propertyData.ownerContacts?.length) {
					this.ownerContact = this.propertyData.ownerContacts[0];
				}

				// Set BWOF
				if (this.propertyData.propertyBwof)
					this.bwof = this.propertyData.propertyBwof;

				// Set Owner Contact from BWOF or owner contact
				this.ownerContact = this.bwof.ownerContact != null ? this.bwof.ownerContact : this.ownerContact;
			}
		}

		formattedDate(date: Date) {
			if (!isValid(date)) return;

			return format(date, 'd MMMM yyyy');
		}

		// Gets all services from the same supplier and the Parent Service is BWOF
		get visibleServices() {
			let services: PropertyServiceData[] = [];

			// Get Services
			if (this.propertyData.services && this.propertyData.propertyId && this.service.supplierCompanyId) {
				services = Get12aPropertyServicesForSupplier(this.propertyData.services, this.propertyData.propertyId, this.service.supplierCompanyId);
			}

			return services;
		}
	}
</script>
<style scoped lang="scss">
	body, table td {
		font-size: 12px;
		line-height: 20px;
		font-family: arial, sans serif;
	}

	.title {
		text-decoration: underline;
		font-size: 14px;
		text-transform: uppercase;
	}

	.full-width {
		width: 750px;
	}

	@media print {
		.full-width {
			width: 100%;
		}

		div#overall-body {
			width: 100%;
			background-color: white;
		}
	}
</style>